// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1n9PG","footer":"ModalUpdate_footer__2Mx-n"};